export const links = [
    { labelLocale: 'layout_footer_navlink_vita_group', to: 'https://vitagroup.com/' },
    {
        labelLocale: 'layout_footer_navlink_privacy_policy',
        to: 'https://www.vitastudent.com/privacy-policy/',
    },
    {
        labelLocale: 'layout_footer_navlink_legal_notice',
        to: 'https://www.vitastudent.com/legal-notice/',
    },
    {
        labelLocale: 'layout_footer_navlink_agents_partners',
        to: 'https://www.vitastudent.com/en/agents-partners/',
    },
];

export const linksHos = [
    {
        labelLocale: 'layout_footer_navlink_privacy_policy',
        to: 'https://www.houseofsocial.com/privacy-policy/',
    },
    {
        labelLocale: 'layout_footer_navlink_legal_notice',
        to: 'https://www.houseofsocial.com/legal-notice/',
    },
    {
        labelLocale: 'layout_footer_navlink_faq',
        to: 'https://www.houseofsocial.com/faqs/',
    },
];
